"use client"

import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { LogOut } from "lucide-react"
import { Button } from "./ui/button"
import logo from '../asset/img/logo.png'
// import logoIcon from '../asset/img/logo-icon.png'
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar"
import { LocationSwitcher } from "./LocationSwitcher"
import { useAuth } from '../context/AuthContext'
// import { useDashboardChat } from '../context/DashboardChatContext'
// import { isAdminRole } from '../constants/roles'
import toast from "react-hot-toast"

export function AppHeader() {
    const { currentUser, logout, isAuthenticated } = useAuth();
    // const { openChat, isOpen } = useDashboardChat();
    // const canUseChat = isAdminRole(String(currentUser?.role || "").trim());
    const username = localStorage.getItem("username") || "";

    const profileImage = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null;
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    let storedRole = "";
    try {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            storedRole = JSON.parse(storedUser)?.role || "";
        }
    } catch {
        storedRole = "";
    }

    const displayName = (username || currentUser?.name || 'User')
        .toString()
        .trim()
        .split(/\s+/)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ');

    const displayRole = String(currentUser?.role || storedRole || "").trim();

    const handleLogout = async () => {
        setIsLoggingOut(true);
        try {
            await logout();
            toast.success("Logout successful!")
            navigate('/');
        } catch (error) {
            toast.error("Logout successful")
        } finally {
            setIsLoggingOut(false);
        }
    };

    return (
        <header className="fixed top-0 left-0 right-0 z-50 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 py-3 shadow-md sm:px-6">
            <div className="flex items-center gap-3 sm:gap-4 min-w-0 flex-1">
                <LocationSwitcher />
                <div className="hidden sm:block h-8 w-px bg-gray-200 shrink-0" />
                <div className="flex items-center gap-2 min-w-0">
                    <Avatar className="h-9 w-9 shrink-0">
                        <AvatarImage src={profileImage?.profileimage} alt="User" />
                        <AvatarFallback>
                            <svg width="36" height="36" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="32" cy="32" r="32" fill="#E0E0E0" />
                                <circle cx="32" cy="24" r="12" fill="#BDBDBD" />
                                <path d="M16 52c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#BDBDBD" />
                            </svg>
                        </AvatarFallback>
                    </Avatar>
                    <div className="hidden md:flex flex-col overflow-hidden min-w-0">
                        <span className="text-sm font-medium truncate capitalize">{displayName}</span>
                        {displayRole && (
                            <span className="text-xs text-indigo-600 font-medium truncate">
                                Role: {displayRole}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-2 sm:gap-3 pointer-events-none">
                <img src={logo} alt="Elite Poker Lounge McAllen" className="h-10 sm:h-12 w-auto max-w-[150px] sm:max-w-[190px] object-contain" />
                <div className="text-left leading-tight hidden sm:block">
                    <span className="text-sm sm:text-base font-bold text-gray-900 tracking-wide block">
                        McAllen
                    </span>
                    <span className="text-[11px] text-yellow-600 font-medium uppercase tracking-wider">
                        Dashboard &amp; Analytics
                    </span>
                </div>
            </div>

            <div className="flex items-center justify-end gap-2 sm:gap-3 flex-1">
                {/* Analytics Bot hidden for now */}
                {/* {isAuthenticated && canUseChat && (
                    <button
                        type="button"
                        onClick={openChat}
                        className={`group relative inline-flex items-center gap-2.5 overflow-hidden rounded-full border px-2 py-1.5 sm:px-3 sm:py-1.5 transition-all duration-300 ${
                            isOpen
                                ? 'border-amber-400/70 bg-gradient-to-r from-amber-50 to-yellow-50 text-slate-900 shadow-[0_8px_24px_rgba(251,191,36,0.25)]'
                                : 'border-slate-200/80 bg-white text-slate-800 shadow-sm hover:border-amber-300/70 hover:shadow-[0_10px_28px_rgba(15,23,42,0.08)]'
                        }`}
                        title="Open Analytics Bot"
                        aria-label="Open Analytics Bot"
                    >
                        <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(251,191,36,0.18),transparent_55%)] opacity-0 transition group-hover:opacity-100" />
                        <span className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-slate-950 to-slate-800 p-[2px] shadow-sm">
                            <span className="flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-white">
                                <img src={logoIcon} alt="EPL" className="h-6 w-6 object-contain" />
                            </span>
                            <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)] ring-2 ring-white" />
                        </span>
                        <span className="relative hidden sm:flex flex-col items-start leading-tight pr-1">
                            <span className="text-xs font-semibold">Analytics Bot</span>
                        </span>
                    </button>
                )} */}
                {isAuthenticated ? (
                    <Button
                        variant="outline"
                        className="flex items-center gap-2 bg-white border border-red-500 text-red-600 hover:bg-red-50 hover:text-red-700 rounded-md px-3 sm:px-4 py-2 transition-all duration-200 shadow-sm"
                        onClick={handleLogout}
                        disabled={isLoggingOut}
                    >
                        {isLoggingOut ? (
                            <>
                                <span className="animate-spin mr-2">
                                    <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </span>
                                <span className="hidden sm:inline">Logging out...</span>
                            </>
                        ) : (
                            <>
                                <LogOut size={18} strokeWidth={2} />
                                <span className="font-medium hidden sm:inline">Logout</span>
                            </>
                        )}
                    </Button>
                ) : (
                    <Link to="/login">
                        <Button variant="ghost" className="flex items-center gap-2 text-red-500 hover:text-red-600">
                            <span>Login</span>
                        </Button>
                    </Link>
                )}
            </div>
        </header>
    )
}
